var r={exports:{}};export{r};
//# sourceMappingURL=index23.js.map
